export default __webpack_public_path__ + "static/media/USDC.046b3f53.svg";